module.exports = __webpack_public_path__ + "img/frame_2.c14334f.png";